import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

import DoneCheckIcon from '@/ui/assets/DoneCheckIcon'
import { useUserSharedBaseRoutes } from '@/ui/hooks/usePersonaBaseUrl'

export default function CompleteRevisionMedicalRecordModal({
  onClose,
  patientId,
  patientName
}: {
  onClose: () => void
  patientId: string
  patientName: string
}) {
  const navigate = useNavigate()
  const userSharedBaseRoutes = useUserSharedBaseRoutes()

  return (
    <Modal
      isOpen
      onClose={onClose}
      isCentered
      scrollBehavior="inside"
      size={'xl'}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p={'10'}>
          <Flex
            flexDir={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={'4'}
          >
            <Flex
              h={'4rem'}
              w={'4rem'}
              borderRadius={'full'}
              bgColor={'custom.system.success'}
              justifyContent={'center'}
              alignItems={'center'}
              mb={'2'}
            >
              <DoneCheckIcon h={'2.5rem'} w={'2.5rem'} color={'white'} />
            </Flex>
            <Text
              fontSize={'1.5rem'}
              fontWeight={'600'}
              lineHeight={'120%'}
              color={'custom.gray.100'}
              textAlign={'center'}
            >
              Dados atualizados com sucesso
            </Text>
            <Text
              fontSize={'0.875rem'}
              fontWeight={'400'}
              color={'custom.gray.300'}
              textAlign={'center'}
            >
              A ficha médica do {patientName} foi atualizada com sucesso! Todas
              as informações foram registradas e estão agora disponíveis.
            </Text>
            <Button
              my={3}
              variant={'link'}
              colorScheme="blue"
              color={'custom.blue.darker'}
              onClick={() =>
                userSharedBaseRoutes
                  ? navigate(
                      userSharedBaseRoutes.dynamic.medicalSheet(patientId)
                    )
                  : onClose()
              }
            >
              Ir para ficha médica do cliente
            </Button>
            <Button
              colorScheme="blue"
              bgColor={'custom.blue.darker'}
              onClick={() => onClose()}
            >
              Voltar para os formulários
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
